var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.922,
    height: 8.875,
    viewBox: "0 0 14.922 8.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Right",
    transform: "translate(2652.461 -272.586) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_585",
    "data-name": "Trazado 585",
    d: "M-8570.51,2919.558l6.047,6.047,6.047-6.047",
    transform: "translate(-2645.558 -5919.463) rotate(-90)",
    fill: "none",
    stroke: "#5ac1dd",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue);
export default __webpack_public_path__ + "static/media/arrowBlue.b3bfbb04bd18522a1792267ca82cb88e.svg";
export { ForwardRef as ReactComponent };